<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>
                        Add New Employee
                    </strong>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-title v-if="this.empdata.serial_track">
                    <strong>
                        Next Employee Code Generated Will Be : {{this.empdata.serial_track}}
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            <br />
            <v-row dense justify="center">
                <v-switch color="#0F2027" label="Add Manual Employee Code" v-model="empdata.mannual_add"></v-switch>
            </v-row>
            <v-row dense justify="center" v-if="empdata.mannual_add">
                <v-col cols="12" sm="3" md="3"> <v-text-field label="Enter Employee Code" rounded outlined dense
                        v-model.trim="empdata.emp_code"></v-text-field></v-col>
            </v-row>
            <v-row dense justify="center">
                <v-col cols="12" sm="3" md="3"> <v-text-field label="Enter Full Name" rounded outlined dense
                        v-model="empdata.fullname"></v-text-field></v-col>
                <v-col cols="12" sm="3" md="3"> <v-text-field label="Enter Institute Email Id" rounded outlined dense
                        v-model="empdata.instituteemail"></v-text-field></v-col>
                <v-col cols="12" sm="3" md="3"> <v-text-field type="number" label="Enter Aadhaar No" rounded outlined
                        dense v-model="empdata.aadharno"></v-text-field></v-col>
                <v-col cols="12" sm="3" md="3"> <v-text-field type="" label="Enter PAN No" rounded outlined dense
                        v-model="empdata.panno"></v-text-field></v-col>
                <v-col cols="12" sm="3" md="3"> <v-text-field :rules="rules" type="number" counter="10"
                        label="Enter Contact No" rounded outlined dense
                        v-model="empdata.contact"></v-text-field></v-col>
                <v-col cols="12" sm="3" md="3"><v-autocomplete rounded outlined dense v-model="empdata.employeetype"
                        :items="emp_type_list" item-text="etname" item-value="etid" label="Select Employee Type" />
                </v-col>
                <v-col cols="12" sm="3" md="3"><v-autocomplete rounded outlined dense v-model="empdata.designation"
                        :items="designation_list" item-text="name" item-value="id" label="Select Designation" />
                </v-col>
            </v-row>
            <v-row dense justify="center">
                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                        transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field outlined dense rounded @blur="date = parseDate(empdata.date_of_birth)"
                                hint="YYYY/MM/DD format" persistent-hint v-model="empdata.date_of_birth"
                                label="Date Of Birth" prepend-icon="mdi-calendar" readonly v-bind="attrs"
                                v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="empdata.date_of_birth" @input="menu2 = false"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-menu v-model="menu3" :close-on-content-click="false" :nudge-right="40"
                        transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field outlined dense rounded @blur="date = parseDate(empdata.date_of_joining)"
                                hint="YYYY/MM/DD format" persistent-hint v-model="empdata.date_of_joining"
                                label="Date Of Joining" prepend-icon="mdi-calendar" readonly v-bind="attrs"
                                v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="empdata.date_of_joining" @input="menu3 = false"></v-date-picker>
                    </v-menu>
                </v-col>
            </v-row>
            <v-row dense justify="center">
                <v-btn @click="saveNewEmpData();" v-if="empdata.date_of_joining && empdata.date_of_birth"
                    class="button">Save</v-btn>
            </v-row>
        </v-card>
    </div>
    <!-- /. root div -->
</template>
<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
        data: () => ({
            rules: [(v) => v.length <= 10 || "Max 10 Number"],
            loader: false,
            // extraBreadcrumbItems: [
          

            // ],
            // breadcrumbClass: "breadcrumb-style1",
            search: "",
            snackbar_msg: "",
            snackbar: false,
            color: "",
            menu: false,
            modal: false,
            modal2: false,
            modal3: false,
            menu2: false,
            menu3: false,
            menu11: false,
            // dateofjoining: null,
            // dob: null
            emp_type_list: [],
            designation_list: [],
            overlay:false,
            empdata: {
                fullname: null,
                aadharno: null,
                instituteemail: null,
                panno: null,
                contact: null,
                employeetype: null,
                designation: null,
                date_of_birth: null,
                date_of_joining: null,
                serial_track: null,
                mannual_add:false,
                emp_code:null,
            },
        }),
        methods: {
            onLoad() {
                axios
                    .post("/Admission/getEMPInitialData")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.empdata.serial_track = res.data.serial_track;
                            this.emp_type_list = res.data.emp_type_list;
                            this.designation_list = res.data.designation_list;
                        } 
                        else if(res.data.flag == "NO"){
                             this.showSnackbar("#b71c1c", res.data.smsg);
                        }
                        else {
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
            },
            saveNewEmpData() {
                this.overlay = true
                axios
                    .post("/Admission/saveNewEmpData", this.empdata)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", "Saved successfully!!!");
                            // this.onLoad();
                        }else if(res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.smsg);
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                        }
                        this.overlay = false
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.overlay = false
                    })
                    .finally(() => {
                        (this.empdata.fullname = null),
                            (this.empdata.aadharno = null),
                            (this.empdata.instituteemail = null),
                            (this.empdata.panno = null),
                            (this.empdata.contact = null),
                            (this.empdata.employeetype = null),
                            (this.empdata.designation = null),
                            (this.empdata.date_of_birth = null),
                            (this.empdata.date_of_joining = null),
                            (this.empdata.serial_track = null);
                            this.overlay = false
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
        mounted() {
            this.onLoad();
        },
        watch: {},
    };
</script>
<style scoped></style>
